import { render, staticRenderFns } from "./chart-labels.vue?vue&type=template&id=6746dfa8&scoped=true&"
import script from "./chart-labels.vue?vue&type=script&lang=js&"
export * from "./chart-labels.vue?vue&type=script&lang=js&"
import style0 from "./chart-labels.vue?vue&type=style&index=0&id=6746dfa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746dfa8",
  null
  
)

component.options.__file = "chart-labels.vue"
export default component.exports